import { createReducer, on } from '@ngrx/store';

import { setCurrentUserId, setUserAdminRole } from './app.actions';
import { CoreOriginalSliceState } from './app.state';

export const coreReducer = createReducer<CoreOriginalSliceState>(
	new CoreOriginalSliceState(),
	on(setUserAdminRole, (state, action) => state.setIsAdmin(action.isAdmin)),
	on(setCurrentUserId, (state, action) =>
		state.setCurrentUserId(action.userId)
	),
	on(setUserAdminRole, (state, action) => state.setIsAdmin(action.isAdmin))
);
